export class EventDetailSetting {
  public id: number;
  public created_at: string;
  public created_id_user: number;
  public email: string;
  public end: string;
  public end_date: string;
  public group_id: any;
  public g_name: string;
  public siteId: any;
  public siteName: any;
  public r_color: string;
  public r_name: string;
  public repeat_parent_id: number;
  public repeat_rule: string;
  public room_id: number;
  public start: string;
  public start_date: string;
  public summary: string;
  public updated_at: string;
  public user_created: string;

  constructor() {
    this.id = null;
    this.created_at = null;
    this.created_id_user = null;
    this.email = null;
    this.end = null;
    this.end_date = null;
    this.group_id = null;
    this.g_name = null;
    this.siteId = null;
    this.siteName = null;
    this.r_color = null;
    this.r_name = null;
    this.repeat_parent_id = null;
    this.repeat_rule = null;
    this.room_id = null;
    this.start = null;
    this.start_date = null;
    this.summary = null;
    this.updated_at = null;
    this.user_created = null;
  }
}



// WEBPACK FOOTER //
// /app/src/app/models/event-detail-setting.ts